import axios from "axios";
const themeChanger = {
	changeTheme: (element) => {
		// ajax to the route.. currently not implemented for multiple themes
		axios.get(`${BASE_URL}toggle-dark-mode`).then((response) => {
			if (response.status === 200) {
				// change the theme
				document.body.classList.toggle("dark")
				// change the icon
				const c = document.body.classList.contains("dark") ? "light_mode" : "dark_mode";
				element.querySelector("#darkToggleSwitch").innerHTML = c;
			}
		})
	}
}

export default themeChanger;